import React, { useContext, useEffect, useState } from "react";
import { Img } from "../../../../components/shared/img";
import { ASSETS_URL, store } from "../../../../components/Store";
import { Icon } from "@iconify/react";
import moment from "moment";
import "moment/locale/es";
import { TimeZones } from "./time-zones";
import { Share } from "./share";
import { ScheduleEvent } from "./schedule-event";
import { useTranslations } from "../../../../hooks/use-translations";
import _ from "lodash";
import { CommunitySignInRequestModal } from "../../../../components/community/community-sign-in-request-modal";


export const EventCard = ({
	eventData,
	lang,
}) => {
	const globalState = useContext(store);
	const isAuth = globalState?.state?.sesionActiva === "SI";
	const texts = useTranslations({ section: "comunidad_club", lang: lang });
	const [showTimeZoneInfo, setShowTimeZoneInfo] = useState(false);
	const [showShare, setShowShare] = useState(false);
	const [showScheduleEvent, setShowScheduleEvent] = useState(false);
	const eventType = eventData?.tipoEvento?.toLowerCase();
	const isPrivateEvent = eventType?.includes("exclusivo");
	const [showSignInModal, setShowSignInModal] = useState(false);
	const title =
		lang === "en"
			? eventData?.titulo?.en || eventData?.titulo?.es || "N/A"
			: eventData?.titulo?.es || "N/A";
	const description =
		lang === "en"
			? eventData?.descripcion?.en || eventData?.descripcion?.es || "N/A"
			: eventData?.descripcion?.es || "N/A";
	const guests = Array.isArray(eventData?.invitados) ? eventData?.invitados?.join(",") : "N/A";
	moment.locale("en");
	const formattedDateEnglish = moment(eventData?.fechasZonas?.co).format(
		"MMM D YYYY [-] hh:mm a"
	);
	moment.locale("es");
	const formattedDateSpanish = moment(eventData?.fechasZonas?.co).format(
		"D [de] MMM YYYY [-] hh:mm a"
	);

	// const imageUrl =
	// 	"https://www.ptf.caltech.edu/system/avm_image_sqls/binaries/2/jpg_original/m42.jpg?1433985441";
	const imageUrl = `${ASSETS_URL}${eventData?.imagenUrl}`;
	const eventAvailable =
		eventData?.estadoBoton && eventData?.estadoBoton?.toLowerCase()?.includes("ver");

	const getTimezones = () => {
		const countries = {
			co: "Colombia",
			cdmx: "México",
			bs: "Argentina",
			cl: "Chile",
			usa: "USA PT",
		};
		if (typeof eventData?.fechasZonas === "object") {
			const dates = Object.entries(countries).map((country) => {
				const key = country[0];
				const countryName = country[1];
				return `${countryName} - ${moment(eventData?.fechasZonas?.[key] || "").format(
					"h:mma"
				)}`;
			});
			return dates;
		}
		return [];
	};

	const handleLinkAccess = (link) => {
		if (isAuth === false && isPrivateEvent) {
			setShowSignInModal(true);
			return;
		}else{
			window.open(link, '_blank');
		}
	};

	return (
		<>
			<article className="event-card my-3 onbackground-primary--color">
				<div className="row p-0 m-0 flex-column-reverse flex-lg-row">
					<div className="col-12 col-lg-4 col-xl-5 p-4">
						<div className={"d-flex"}>
							<p className="px-2 py-1 text-10 event-type secondary-font">
								{`${
									isPrivateEvent
										? `${
												_.get(
													texts,
													"makemake_en_vivo.evento.tipo_evento.privado"
												) || "Evento exclusivo"
										  }`
										: `${
												_.get(
													texts,
													"makemake_en_vivo.evento.tipo_evento.publico"
												) || "Evento público"
										  }`
								}`}
							</p>
						</div>
						<h3 className="title secondary-font my-2">{title}</h3>
						<h4 className="guests secondary-font text-truncate">
							{`${_.get(texts, "makemake_en_vivo.evento.invitados") || "Invitado/s"}`}
							: {guests}
						</h4>
						{/* <p className="youtube-message">
							{_.get(texts, "makemake_en_vivo.evento.mirar_en_youtube") ||
								`Miralo a través del canal de Youtube`}
						</p> */}
						<p className="description my-2">{description}</p>
					</div>
					<div className="col-12 col-lg date-info-container p-0 overflow-hidden">
						<div className="row p-0 m-0 flex-md-row-reverse">
							<div className="col-12 col-md-6 d-flex p-0 m-0 img-container justify-content-center align-items-center justify-contentent-md-end">
								<div className="overflow-hidden w-100 h-100 d-flex justify-content-center align-items-center">
									<Img
										className="w-100 h-100 col-10 col-sm-7 col-md-12 col-lg-12 p-4 p-md-0"
										src={imageUrl}
										defaultImage={"/img/no-imagen2.png"}
										// style={{ borderRadius: "1rem" }}
									/>
								</div>
							</div>
							<div className="col-12 col-md-6 d-flex flex-column p-md-3">
								<div className="d-flex align-items-center mb-2">
									<Icon
										icon="dashicons:calendar-alt"
										className="secondary-inverse--color pr-2"
										width={50}
									/>
									<button
										className="focusable-red d-flex flex-column"
										onClick={() => setShowTimeZoneInfo(true)}
									>
										<p className="font-weight-bold align-items-center">
											{lang === "en"
												? formattedDateEnglish
												: formattedDateSpanish}
										</p>
										<p className="p-0 d-flex align-items-center font-weight-bold secondary-font secondary-inverse--color">
											{`${
												_.get(
													texts,
													"makemake_en_vivo.evento.boton.horarios"
												) || "Horarios"
											}`}
											<Icon icon="iconamoon:arrow-right-2-bold" width={22} />
										</p>
									</button>
								</div>

								<div className="my-2 d-flex flex-column">
									<>
										{/* AL: SE OCULTA LOS BOTONES A PARTIR DE MAYO MIENTRAS SE TIENE EN PRODUCCIÓN LOS NUEVOS FORMULARIOS */}
										{moment(eventData?.mes, "MM").month() + 1 <= 4 ? (
											<>
												{eventAvailable ? (
													<button
														className="focusable-red watch-button d-flex px-4 py-2 my-1 justify-content-center align-items-center text-center"
														onClick={() =>
															handleLinkAccess(eventData?.link)
														}
													>{`${
														_.get(
															texts,
															"makemake_en_vivo.evento.boton.ver"
														) || "Ver"
													}`}</button>
												) : null}

												{eventAvailable === false ? (
													<button
														className="focusable-red light-button d-flex px-4 py-2 my-1 justify-content-center align-items-center text-center"
														onClick={() =>
															handleLinkAccess(eventData?.link)
														}
													>{`${
														_.get(
															texts,
															"makemake_en_vivo.evento.boton.inscribirse"
														) || "Inscríbete"
													}`}</button>
												) : null}

												<button
													className="focusable-red light-button d-flex px-4 py-2 my-1 justify-content-center align-items-center text-center"
													onClick={() => setShowShare(true)}
												>
													{`${
														_.get(
															texts,
															"makemake_en_vivo.evento.boton.compartir"
														) || "Compartir"
													}`}{" "}
													<Icon
														className="pl-2"
														icon="gridicons:share"
														width={30}
													/>
												</button>
											</>
										) : null}
									</>
									<button
										className="focusable-red light-button d-flex px-4 py-2 my-1 justify-content-center align-items-center text-center"
										onClick={() => setShowScheduleEvent(true)}
									>
										{`${
											_.get(texts, "makemake_en_vivo.evento.boton.agendar") ||
											"Agendar"
										}`}{" "}
										<Icon
											icon="mingcute:schedule-fill"
											className="pl-2"
											width={30}
										/>
									</button>
									<TimeZones
										list={getTimezones()}
										visible={showTimeZoneInfo}
										setVisible={setShowTimeZoneInfo}
									/>
									<Share
										link={eventData?.link || ""}
										description={
											eventAvailable
												? _.get(
														texts,
														"makemake_en_vivo.evento.compartir.link_evento"
												  ) || "Copia y comparte el link del evento."
												: _.get(
														texts,
														"makemake_en_vivo.evento.compartir.inscripcion"
												  ) ||
												  "Copia y comparte el link del formulario de inscripción al evento."
										}
										visible={showShare}
										setVisible={setShowShare}
									/>
									<ScheduleEvent
										eventData={eventData}
										visible={showScheduleEvent}
										setVisible={setShowScheduleEvent}
										lang={lang}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</article>
			<CommunitySignInRequestModal
				visible={showSignInModal}
				setVisible={setShowSignInModal}
				title={texts?.popups?.iniciar_sesion?.titulo || "¡Evento exclusivo!"}
				description={
					texts?.popups?.iniciar_sesion?.descripcion ||
					"Para acceder a este contenido inicia sesión."
				}
				buttonText={texts?.popups?.iniciar_sesion?.boton || "Iniciar sesión"}
				redirectionParam={"/club-makemake?section=makemake-en-vivo"}
			/>
		</>
	);
};
